import React, { useState } from 'react';
import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { CloseIcon } from '../Icon';
import PreviewDialog from '../PreviewDialog';
import { onKeyUpEnterOrSpace } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.142rem',
    background: '#F5FAFF',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '1.142rem',
  },
  imgBox: {
    display: 'flex',
    gridGap: '8px',
    alignItems: 'center',
    cursor: 'pointer',
    height: '2.5rem',
    overflow: 'hidden',
  },
  closebox: {
    width: '1.875rem',
    height: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0.938rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  close: {
    width: '1rem',
    height: '1rem',
    color: theme.palette.primary.main,
  },
  loading: {
    color: theme.palette.primary.main,
  },
  fileNameBox: ({ isEHandover }) => ({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '1.142rem',
    fontFamily: 'Noto Sans',
    fontWeight: '500',
    color: '#2E4469',
    overflow: 'hidden',
    flex: 1,
    width: isEHandover ? 'auto' : '8rem',
  }),
}));

export default function ImageUploadPreview({
  name,
  index,
  data,
  setData = () => {},
  previewUrl,
  handleRemove = null,
  isEHandover = true,
  uploading = false,
}) {
  const classes = useStyles({ isEHandover });
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const handleRemoveImg = () => {
    if (uploading) {
      return;
    }
    if (_.isFunction(handleRemove)) {
      handleRemove();
      return;
    }

    if (data[index].previewUrl) {
      URL.revokeObjectURL(data[index].previewUrl);
    }
    setData([...data.slice(0, index), ...data.slice(index + 1)]);
  };

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.imgBox} onClick={() => !uploading && setShowPreviewDialog(true)}>
          <Box width={isEHandover ? '5rem' : '3.2rem'} display="flex" alignItems="center">
            <img src={previewUrl} alt="preview img" width="100%" />
          </Box>
          <Box className={classes.fileNameBox}>{name}</Box>
        </Box>
        <Box
          onClick={handleRemoveImg}
          tabIndex={uploading ? -1 : 0}
          onKeyUp={(e) => !uploading && onKeyUpEnterOrSpace(e, handleRemoveImg)}
          className={classes.closebox}
        >
          {uploading ? <CircularProgress size={18} className={classes.loading} /> : <CloseIcon className={classes.close} />}
        </Box>
      </Box>
      <PreviewDialog
        previewUrl={previewUrl}
        showDialog={showPreviewDialog}
        closePop={() => setShowPreviewDialog(false)}
      />
    </>
  );
}
